import React, { useEffect, useState } from "react";
import Header from "./Header";
import Body from "./Body";
import Login from "./Login";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, logoutUser, selectUser } from "../features/userSlice";
import { auth } from "./firebase";
import { selecttoggleTheme } from "../features/toggleThemeReducer";
import "../CSS/index.css";
import Loader from "./Loader";

function App() {
  const user = useSelector(selectUser);
  const toggleTheme = useSelector(selecttoggleTheme);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged((userAuth) => {
      if (userAuth) {
        //already logged in
        dispatch(
          loginUser({
            email: userAuth.email,
            uid: userAuth.uid,
            photoURL: userAuth.photoURL,
            displayName: userAuth.displayName,
          })
        );
      } else {
        //logged out
        dispatch(logoutUser(null));
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    });
  }, [dispatch]);
  return (
    <>
      {!user ? (
        loading ? (
          <Loader />
        ) : (
          <Login />
        )
      ) : (
        <div
          className="app"
          style={{ backgroundColor: toggleTheme ? "#151515" : "#f3f2ef" }}
        >
          <Header />
          <Body />
        </div>
      )}
    </>
  );
}

export default App;
